// extracted by mini-css-extract-plugin
export default {"ButtonBacks":"ButtonLink_ButtonBacks__jatfL","ButtonDisabled":"ButtonLink_ButtonDisabled__0rBXM"};